<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuth } from '@zayouth/uikit/auth-client'
import { loginPath } from '@zayouth/uikit/shared/utils/module'
import { ZyAppHeader, ZyUserMenu, ZyToast, ZyConfirm } from '@zayouth/uikit/ui-kit'

const auth = useAuth()

// 登录页独立在 auth.zayouth.com（C-020）；此处按 uikit 规则推导绝对地址，
// 不可写死相对路径 `/auth/login`（那会落到 portal 前端的空路由 → 白屏）。
const loginHref = loginPath(window.location.href)

onMounted(() => {
  void auth.ensureAuth()
})
</script>

<template>
  <div class="zy-app-shell portal-shell zy-harbor-surface">
    <ZyAppHeader current="portal">
      <template v-if="auth.initialized">
        <ZyUserMenu v-if="auth.isLoggedIn" />
        <a v-else class="shell-login" :href="loginHref">登录</a>
      </template>
    </ZyAppHeader>
    <RouterView />
    <ZyToast />
    <ZyConfirm />
  </div>
</template>
